import React from 'react';

const Masthead = () => {
  return (
    <header className="bg-gradient-to-br from-blue-2 to-dark-2 text-white py-12 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8">
        {/* Section texte */}
        <div className="flex-1 space-y-6">
          <h1 className="font-sans text-3xl md:text-4xl lg:text-title font-bold leading-tight">
            Transformez votre école en un espace d'innovation avec Little Maker.
          </h1>
          <p className="font-sans text-normal md:text-lg text-light-3 leading-relaxed">
            NextMaker propose aux écoles une <span className="font-bold">plateforme d'apprentissage</span> innovante qui initie les enfants (7–11 ans) à la robotique, au codage et à la créativité.
          </p>
          <p className="font-sans text-normal md:text-lg text-light-3 leading-relaxed">
            Avec des options <span className="font-bold text-green-1">individuelles</span> ou <span className="font-bold text-purple-1">collectives</span>, chaque établissement peut trouver la formule qui correspond à ses besoins.
          </p>
          <div className="flex flex-wrap gap-4 mt-6">
            <button className="bg-red-4 hover:bg-transparent text-white hover:text-red-4 font-sans py-3 px-6
            rounded-full transition-colors duration-300 border-2 border-red-4 text-button">
              Découvrir les offres
            </button>
            <button className="border-2 border-red-4 hover:bg-red-4 text-white font-sans py-3 px-6 rounded-full
            transition-colors duration-300 text-button">
              Contacter un expert
            </button>
          </div>
        </div>
        
        {/* Section illustration */}
        <div className="flex-1 flex justify-center">
          <div className="relative w-full max-w-md">
            {/* Illustration représentant une classe en atelier créatif */}
            <div className="relative w-full aspect-square bg-dark-5 rounded-2xl p-6 overflow-hidden">
              {/* Tableau de classe */}
              <div className="absolute top-4 left-4 right-4 h-16 bg-white rounded-lg"></div>
              <div className="absolute top-5 left-5 right-5 h-14 bg-light-3 rounded"></div>
              
              {/* Groupes d'enfants */}
              <div className="absolute top-24 left-6 w-12 h-12 bg-red-4 rounded-full"></div>
              <div className="absolute top-28 left-20 w-10 h-10 bg-blue-1 rounded-full"></div>
              
              <div className="absolute top-32 right-16 w-12 h-12 bg-green-1 rounded-full"></div>
              <div className="absolute top-36 right-6 w-10 h-10 bg-purple-1 rounded-full"></div>
              
              {/* Équipements technologiques */}
              <div className="absolute bottom-8 left-8 w-16 h-12 bg-dark-3 rounded-lg flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>
                </svg>
              </div>
              
              <div className="absolute bottom-8 right-8 w-14 h-10 bg-dark-3 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </div>
              
              {/* Éléments de créativité */}
              <div className="absolute top-20 left-1/2 transform -translate-x-1/2 w-6 h-6 bg-yellow-400 rounded-full"></div>
              <div className="absolute top-16 left-2/4 w-4 h-4 bg-red-2 rounded-full"></div>
              <div className="absolute top-14 right-1/4 w-5 h-5 bg-blue-1 rounded-full"></div>
              
              {/* Lignes de connexion créative */}
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
                <line x1="20" y1="40" x2="40" y2="50" stroke="#6440FB" strokeWidth="0.5" />
                <line x1="80" y1="45" x2="60" y2="55" stroke="#5347EB" strokeWidth="0.5" />
                <line x1="30" y1="70" x2="50" y2="65" stroke="#F94A56" strokeWidth="0.5" />
                <line x1="70" y1="68" x2="55" y2="62" stroke="#00FF84" strokeWidth="0.5" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Masthead;